<template>
	<footer class="m-grid__item		m-footer ">
		<div class="m-container m-container--fluid m-container--full-height m-page__container">
			<div class="m-stack m-stack--flex-tablet-and-mobile m-stack--ver m-stack--desktop">
				<div class="m-stack__item m-stack__item--left m-stack__item--middle m-stack__item--last">
					<span class="m-footer__copyright">
						{{`${new Date().getFullYear()} &copy; Superaccess`}}
						<a href="#" class="m-link">
						</a>
          </span>
        </div>
        <div class="m-stack__item m-stack__item--right m-stack__item--middle m-stack__item--first">
          <div class="m-dropdown m-dropdown--up m-dropdown--inline m-dropdown--smallest m-dropdown--arrow m-dropdown--align-right m-dropdown--align-push" data-dropdown-toggle="click">
            <a href="#" class="m-portlet__nav-link m-dropdown__toggle btn btn-secondary m-btn m-btn--icon m-btn--pill">
              <span class="m-nav__link-text">
                <img :src="'/media/img/flags/'+$i18n.locale+'.png'" class="carousel-control-next-icon icon-flag-selector">
                {{ $i18n.locale | translate | titleize }}
              </span>
            </a>
            <div class="m-dropdown__wrapper language-dropdown">
              <div class="m-dropdown__inner">
                <div class="m-dropdown__body">
                  <div class="m-dropdown__content">
                    <div class="m-scrollable" data-scrollable="true" data-max-height="110" data-max-width="150">
                      <ul class="m-nav text-nowrap">
                        <li v-for="(language,index) in  Object.keys($i18n.messages)" :key="index" class="m-nav__item">
                          <a @click="setLanguage(language)" class="m-nav__link cursor-pointer">
                            <span class="m-nav__link-text ">
                              <img :src="`/media/img/flags/${language}.png`" class="carousel-control-next-icon icon-flag-selector">
                              {{ language | translate | titleize }}
                            </span>
                          </a>
                        </li>
                      </ul>																
                    </div>
                  </div>
                </div>
				      </div>
	          </div>
          </div>
        </div>
			</div>
		</div>
	</footer>
</template>

<script>
export default {
  methods: {
    setLanguage (lang) {
      if (this.$i18n.locale !== lang) {
        this.$spinner.show()
        this.$store.dispatch('getEditLanguage', lang)
          .then((res) => {
            if (res.data) {
              this.$spinner.remove()
              this.$toast('language_message_modified')
            } else {
              this.$spinner.remove()
              this.$toast('language_error', 4)
            }
          })
        this.$i18n.locale = lang
        this.$validator.localize(lang)
      }
    }
  }
}
</script>

<style scoped>
.m-dropdown.m-dropdown--smallest .m-dropdown__wrapper {
  min-width: 160px
}
</style>



// WEBPACK FOOTER //
// Footer.vue